import { call, put } from "redux-saga/effects";
import { Decrypt_Value } from "../EncryptDecrypt";
import { setMembershipPlans } from "../../StateManagement/Reducers/MembershipState";
import { MembershipPlans_Api } from "../Apis/MembershipApi";

export function* MembershipPlansWorker() {
  try {
    const res = yield call(MembershipPlans_Api);

    if (res.status === 200) {
      const decryptedResponse = Decrypt_Value(res.data, "vozoportalapp");
      yield put(setMembershipPlans(decryptedResponse || []));
    }
  } catch (e) {
    console.log("Membership API Error:", e.message);
    yield put(setMembershipPlans([]));
  }
}
